import { render, staticRenderFns } from "./AddFormData.vue?vue&type=template&id=f1071d14&scoped=true&"
import script from "./AddFormData.vue?vue&type=script&lang=js&"
export * from "./AddFormData.vue?vue&type=script&lang=js&"
import style0 from "./AddFormData.vue?vue&type=style&index=0&id=f1071d14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1071d14",
  null
  
)

export default component.exports